<section class="mx-5 my-3">
   <header>
      <h2>{{translate.getLng('SETTINGS')}}</h2>
      <p class="pb-2">{{translate.getLng('SETTINGS_INFO')}}</p>
      <!-- <h6>{{translate.getLng('EDIT')}}<span class="text-secondary"> ({{translate.getLng('SHIPPING_ADDRESS')}})</span> 
      </h6> -->
   </header>
   <!-- <div flex fxLayout="row" fxLayout.lt-sm="column">
      <div fxFlex="50">
         <mat-form-field class="w-75">
            <mat-label>{{translate.getLng('COMPANY')}}</mat-label>
            <input matInput value="">
         </mat-form-field>
         <mat-form-field class="w-75">
            <mat-label>{{translate.getLng('CONTACT_PERSON')}}</mat-label>
            <input matInput value="">
         </mat-form-field>
         <div class="w-75">
            <sen-app-input-address ></sen-app-input-address>
         </div>
         <mat-form-field class="w-75">
            <mat-label>{{translate.getLng('PHONE')}}</mat-label>
            <input matInput value="">
         </mat-form-field>
         <mat-form-field class="w-75">
            <mat-label>{{translate.getLng('FAX')}}</mat-label>
            <input matInput value="">
         </mat-form-field>
         <mat-form-field class="w-75">
            <mat-label>{{translate.getLng('EMAIL')}}</mat-label>
            <input matInput value="">
         </mat-form-field>
      </div>-->

   <div [formGroup]="form">
      <mat-form-field class="w-25">
         <mat-label>{{translate.getLng('COM_LOGO')}}</mat-label>
         <ngx-mat-file-input formControlName="blobImage" #image type="file"
            (change)="handlefileInput($event.target.files)" accept="image/x-png,image/gif,image/jpeg">
         </ngx-mat-file-input>
         <mat-icon class="sen-active-color sen-cursor-pointer" matSuffix>attach_file</mat-icon>
         <mat-hint align="end"></mat-hint>
      </mat-form-field>
      <button color="primary" (click)="saveSettingData()"
         class="mat-focus-indicator px-5 py-2 float-right mat-raised-button mat-button-base mat-primary">
         <span class="mat-button-wrapper">{{translate.getLng('SAVE')}}</span>
      </button>
   </div>

   <div class="mt-3 sen-preview-block">
      <img *ngIf="imageUrl" [src]="imageUrl">
   </div>

</section>